/**
 * objectLengthFilter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function objectLengthFilter() {
    return object => {
        return angular.isObject(object) ? Object.keys(object).length : 0;
    };
}
